import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-datatable-search-layout',
  templateUrl: './datatable-search-layout.component.html',
  styleUrls: ['./datatable-search-layout.component.scss'],
  standalone: false,
})
export class DatatableSearchLayoutComponent {
  @Input() hideTable = false;
  @Input() showCard = true;

  @HostBinding('class.fill') get fill(): boolean {
    return !this.hideTable;
  }
}
